query getSavedContents($input: GetSavedContentsInput!) {
  savedContents: getSavedContents(input: $input) {
    page
    perPage
    total
    savedContents {
      id
      text
      imagePath
      imageSource
      textKind
      createdAt
      postedAt
      url
      carouselImages
      downloaded
      topicId
      postingBatchId
      invitationIds
      totalOffices
      totalRecipients
      recipientSegment
      targetLink
      topicName
      publication
      invitations {
        name
        recipientCount
        targetLink
        failedCount
        failedDeliveryError
      }
      platformTexts {
        INSTAGRAM
        LINKEDIN
      }
      officeCount
      accountCount
      socialMediaPosts {
        id
        type
        permalink
        externalPostId
        completedAt
        hasFailed
        failureReason
        metrics {
          impressions
          likes
          comments
          shares
          fetchedAt
        }
      }
    }
  }
}
